import { useCallback } from "react";
import notificationsCenter from "../../singleton/NotificationsCenter";

export function useUnavailableToolbarAction(reason) {
  return useCallback(
    event => {
      if (!reason) {
        return false;
      }

      event?.preventDefault?.();
      event?.stopPropagation?.();
      notificationsCenter.info(reason, null, { timeout: 3000 });

      return true;
    },
    [reason]
  );
}
